import React from "react";
import { StatusBar, StyleSheet } from "react-native";
import { Box, MainButton, MySafeAreaView } from "../../components/common";
import { useSelector } from "react-redux";
import i18n from "@microdoing/shared/i18n";
import TrackCard from "../UserTracksScreen/TrackCard";
import selectLanguage from "../../utils/selectLanguage";
import { getSurveyId } from "@microdoing/shared/services/survey/selectors";
import {
  getCampaignSelected,
  getOnboardingSurveyId,
} from "@microdoing/shared/services/userCampaign/selectors";
import { getLanguage } from "@microdoing/shared/services/profileSettings/selectors";
import theme from "app/Theme/Theme";
import HeaderScreen from "app/components/common/HeaderScreen";
import { isWeb, isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import WebNewCampaignModal from "./WebNewCampaignModal";
import { SafeAreaView } from "react-native-safe-area-context";

export const DEFAULT_PICTURE =
  "https://pulse-experience.s3.eu-west-3.amazonaws.com/images/background.png";

const styles = StyleSheet.create({
  modal: {
    alignContent: "center",
    justifyContent: "space-between",
    backgroundColor: theme.colors["neutral.white"],
    flex: 1,
    width: "100%",
  },
});

const NewCampaignModal = ({ navigation }) => {
  const campaignSelected = useSelector(getCampaignSelected);
  const surveyId = useSelector(getSurveyId);
  const onboardingSurveyId = useSelector(getOnboardingSurveyId);
  const language = useSelector(getLanguage);

  const { picture, title, description } = campaignSelected;

  const next = () => {
    if (onboardingSurveyId && surveyId && surveyId === onboardingSurveyId) {
      return navigation.replace("Survey");
    }
    navigation.replace("Main");
  };

  if (isWebDesktop) {
    return <WebNewCampaignModal goNext={next} />;
  }

  return (
    <MySafeAreaView backgroundColor="neutral.white" flex={1}>
      <Box
        variant="screenView"
        backgroundColor="neutral.white"
        flex={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <StatusBar backgroundColor={theme.colors["neutral.white"]} />
        <Box width={isWeb ? 460 : "100%"}>
          <HeaderScreen title={i18n.t("new-campaign-title")} />
        </Box>
        <TrackCard
          backgroundSource={{ uri: picture || DEFAULT_PICTURE }}
          label={i18n.t("label-current")}
          onPress={next}
          subtitle={selectLanguage({
            text: description,
            language,
          })}
          largeTitle={selectLanguage({
            text: title,
            language,
          })}
        />
        <Box width={isWeb ? 460 : "100%"}>
          <MainButton text={i18n.t("start")} onPress={next} />
        </Box>
      </Box>
    </MySafeAreaView>
  );
};

export default NewCampaignModal;
